export default {
    hasError(state) {
        return state.hasError;
    },
    formHasError(state) {
        return state.formHasError;
    },
    warningPanelText(state) {
        return state.warningPanelText;
    },
    pageIsLoading(state) {
        return state.pageIsLoading;
    },
    dialogOpened(state) {
        return state.dialogOpened;
    },
    isExplainableError(state) {
        return state.isExplainableError;
    },
    explainInProgress(state) {
        return state.explainInProgress;
    }
}